import './Header.css'
import { Container, Row, Col, Dropdown } from 'react-bootstrap'
import { ToastContainer } from 'react-toastify'
import { ITheme, darkTheme, lightTheme } from 'theme/theme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Switch } from '@progress/kendo-react-inputs'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IRootState } from 'types'
import { AppDispatch } from 'state/store'
import { logoutAction } from 'state/actions/userActions'
import { useNavigate } from 'react-router-dom'
import DefaultButton from 'components/Buttons/DefaultButton/DefaultButton'
import { MenuRouteDto } from '@v1UsersApi'
import toast from 'core/toast'

interface IProps {
  themeChanged: (theme: ITheme) => void
  theme: ITheme
}

const Header = (props: IProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()

  const authenticated = useSelector((state: IRootState) => state.user.authenticated)
  const routes = useSelector((state: IRootState) => state.app.routes)
  const loading = useSelector((state: IRootState) => state.app.loading)
  const multiFactorVerified = useSelector((state: IRootState) => state.user.multiFactorConfirmed)
  const multiFactorLoginEnabled = useSelector((state: IRootState) => state.user.multiFactorLoginEnabled)

  const toggleTheme = () => {
    props.themeChanged(props.theme.name === lightTheme.name ? darkTheme : lightTheme)
    localStorage.setItem('theme', props.theme.name === lightTheme.name ? darkTheme.name : lightTheme.name)
  }

  const Logo = () => {
    return (
      <h1 className='my-3'><i><FontAwesomeIcon icon='folder-gear' /> System Admin</i></h1>
    )
  }

  const handleLogoutOnClick = async () => {
    await dispatch(logoutAction(navigate))
  }

  const goToNewRoute = (tabRouteSysAdminId: number) => {
    let item: MenuRouteDto | undefined = routes?.find(r => r.tabRouteSysAdminId === tabRouteSysAdminId)
    if (!item || !item.route) {
      toast.error('Route not found')
      return
    }

    navigate(item.route)
  }

  if (location.pathname !== process.env.REACT_APP_LOGIN_REDIRECT
    && (!routes || routes.length === 0 || routes.find(r => r.route === location.pathname)?.hideHeader))
    return <></>

  if (!authenticated)
    return <></>

  return (
    <div id='header'>
      <Container fluid>
        <Row>
          <Col xs={7}>
            <Logo />
          </Col>

          <Col xs={5} className='text-end' style={{ alignSelf: 'center' }}>

            {(!multiFactorLoginEnabled || multiFactorVerified) && <Dropdown drop='down'>
              <Dropdown.Toggle variant='default' className='btn-sm ms-1' id='dropdown-basic'>
                <FontAwesomeIcon icon='gear' />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>
                  Theme: <Switch defaultValue={props.theme.name} defaultChecked={props.theme.name === 'dark' ? true : false} id='themeSwitch' onLabel={'Dark'} offLabel={'Light'} onChange={() => toggleTheme()} />
                </Dropdown.Item>
                <Dropdown.Item onClick={() => goToNewRoute(36)}>Login Settings</Dropdown.Item>
                <Dropdown.Item href={`${process.env.REACT_APP_OLD_SYS_ADMIN_URL}/web/MyProfile/EditHomePage.aspx`}>Edit Home Page</Dropdown.Item>
                <Dropdown.Item href={`${process.env.REACT_APP_OLD_SYS_ADMIN_URL}/web/MyProfile/EditTabs.aspx`}>Edit Tabs</Dropdown.Item>
                <Dropdown.Item href={`${process.env.REACT_APP_OLD_SYS_ADMIN_URL}/web/MyProfile/MyFavoriteReports.aspx`}>My Favorite Reports</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            }

            <DefaultButton
              title='Log Out'
              className='btn-sm ms-1'
              variant='default'
              spinnerVariant='default'
              disabled={loading}
              onClick={handleLogoutOnClick}>
              <FontAwesomeIcon icon='sign-out' /> Log Out
            </DefaultButton>
          </Col>
        </Row>
      </Container>
    </div >
  )
}

export default Header